var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"md":"12","cols":"12"}},[_c('card-statistics-group')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }